import * as style from '../../utils/general_style.js';

function Engagements({ icon, alt, text }) {
	return (
        <div style={style.COLUMN_CENTER}>
            <div style={{width: '80px', height: '80px', marginBottom: '15px'}}>
                <img src={ icon } alt={ alt } />
            </div>
            {text}
        </div>
	);
};

export default Engagements;